import { useState } from "react";
import type { PeriodSummaryMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryMode.ts";
import { useRouteParam } from "@/shared/routing/useRouteParam.ts";
import { parseIsoDate } from "@/shared/utils/Dates.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import { LEGACY_TIME_ZONE } from "@/shared/utils/LegacyDates.ts";
import type { PeriodSummaryRange } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryRange.ts";
import useScheduleRangeOnRoute from "@/pages/human-resources/time-management/hooks/useScheduleRangeOnRoute.ts";

interface Controller {
  domainId: string;
  siteId: string;
  date: Date;
  range: PeriodSummaryRange;
  mode: PeriodSummaryMode;
  setMode: (mode: PeriodSummaryMode) => void;
}

export function usePeriodSummaryCardController(
  initialMode: PeriodSummaryMode,
): Controller {
  const {
    domainData: { domainId },
    siteData: { siteId },
  } = useScheduleReferenceData();
  const dateStr = useRouteParam("date");
  const date = parseIsoDate(dateStr, LEGACY_TIME_ZONE);
  const range = useScheduleRangeOnRoute();
  const [mode, setMode] = useState<PeriodSummaryMode>(initialMode);

  return {
    domainId,
    siteId,
    date,
    range,
    mode,
    setMode,
  };
}
